import { Component, ViewChild } from "@angular/core";
import { NgbModule, NgbNavModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { PiezeoSensorMonitoringComponent } from "../piezeo-sensor-monitoring/piezeo-monitoring.component";
import { PiezoDiagnostics } from "../diagnostics/diagnostics.component";
import { PiezoPredictive } from "../predictive/predictive.component";
import { ActivatedRoute, Router } from "@angular/router";
import { L, S } from "@angular/cdk/keycodes";
import { ConvertDatetimePipe } from "../../../../app/convert-datetime.pipe";
import { AssetHealthBoxComponent } from "../../../asset-health-box/asset-health-box.component";
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from "@angular/material/icon";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { NgStyle } from "../../../../../node_modules/@angular/common/index";
import { SettingsModalComponent } from "../../../../app/components/settings-modal/settings-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { ServiceStatusSettingsComponent } from "./service-status-settings/service-status-settings.component";
import { AlertSettingsComponent } from "./alert-settings/alert-settings.component";
import { PlateDetailsComponent } from "./plate-details/plate-details.component";
@Component({
  selector: 'app-piezo-sensor-dashboard',
  templateUrl: './piezo-sensor-dashboard.component.html',
  styleUrl: './piezo-sensor-dashboard.component.scss',
  standalone: true,
  imports: [NgbTooltipModule, NgbNavModule, PiezeoSensorMonitoringComponent, PiezoDiagnostics, PiezoPredictive, AssetHealthBoxComponent, MatMenuModule, MatIcon, NgStyle]
})

export class PiezoSensorDashboard {
  @ViewChild("ctdTabset") ctdTabset;
  active_tab_id = 'tab-1';
  subsystem_data: any = {};
  piezoMapping: any = {};
  childComponentData: any = {};

  public breadcrumbsArray: any = [
    {
      page_ref: "piezo-dashboard",
      page_title: "Powertrain Dashboard",
    },
    {
      page_ref: "#",
      page_title: "Piezo Device Dasboard",
    },
  ];

  displacement = [40, 41, 42];
  acceleration = [43, 44, 45];
  temperature = [46, 47, 48];
  velocity = [49, 50, 51];
  company_name = localStorage.getItem('company_name')
  today: Date;
  public clientId = localStorage.getItem('user_id');
  public loadingLastFileTime: boolean = false;
  public lastFileTime: string = "";
  public loadingDeviceStatus: boolean = false;
  public deviceStatus: string = "";
  public latestFFTId: number;
  public latestKurtosisId: number;
  intervalRef: any;
  public loadingService: boolean = false;
  public serviceData: any = null;
  public loadingAlertSettings: boolean = false;
  public alertSettingsData: any = null;
  public loadingPlateDetails: boolean = false;
  public plateDetailsData: any = null;
  public BHEL_ON_PREM: boolean = BaseUrlConstantsService.BHEL_ON_PREM;

  constructor(private router: ActivatedRoute, private service: BackendApiService, private dialog: MatDialog,private rt:Router) { this.utcTime(); }

  ngOnInit() {
    this.subsystem_data = this.router.snapshot.queryParams;
    console.log("Sub param: ", this.subsystem_data)
    this.latestFFTId = this.subsystem_data.latestFFTId;
    // this.latestFFTId = 3337230;
    this.latestKurtosisId = this.subsystem_data.latestKurtosisId;
    this.buildMetricMapping();
    this.fetchLastFileTime();
    this.fetchDeviceStatus();

    this.intervalRef = setInterval(() => {
      this.fetchLastFileTime();
      this.fetchDeviceStatus();
    }, 30000);
  }

  ngOnDestroy() {
    if (this.intervalRef) {
      clearInterval(this.intervalRef);
    }
  }

  onTabChangeRequest(tabId: string) {
    this.active_tab_id = tabId;
  }

  buildMetricMapping() {
    let sensors_info = {};
    try {
      sensors_info = typeof this.subsystem_data.sensors_info === 'string'
        ? JSON.parse(this.subsystem_data.sensors_info)
        : this.subsystem_data.sensors_info || {};
    } catch (e) {
      console.error('Error parsing sensors_info:', e);
      sensors_info = {};
    }

    const no_of_axis = this.subsystem_data.no_of_axis || 0;

    // Extract channels based on axis
    let displacementChannels = [];
    let accelerationChannels = [];
    let temperatureChannels = [];
    let velocityChannels = [];

    for (let i = 1; i <= no_of_axis; i++) {
      const axisKey = `sensor_${i}_axis`;
      const axis = sensors_info[axisKey];

      if (axis === 'X') {
        displacementChannels.push(this.displacement[0]);
        accelerationChannels.push(this.acceleration[0]);
        // temperatureChannels.push(this.temperature[0]);
        velocityChannels.push(this.velocity[0]);
      } else if (axis === 'Y') {
        displacementChannels.push(this.displacement[1]);
        accelerationChannels.push(this.acceleration[1]);
        // temperatureChannels.push(this.temperature[1]);
        velocityChannels.push(this.velocity[1]);
      } else if (axis === 'Z') {
        displacementChannels.push(this.displacement[2]);
        accelerationChannels.push(this.acceleration[2]);
        // temperatureChannels.push(this.temperature[2]);
        velocityChannels.push(this.velocity[2]);
      }
    }
    temperatureChannels.push(this.temperature[0]);

    displacementChannels.sort((a, b) => a - b);
    accelerationChannels.sort((a, b) => a - b);
    temperatureChannels.sort((a, b) => a - b);
    velocityChannels.sort((a, b) => a - b);
    this.childComponentData = {
      clientId:this.subsystem_data.client_id,
      assetId: this.subsystem_data.asset_id,
      inventoryId: this.subsystem_data.inventory_id,
      gatewayId: this.subsystem_data.gateway_id,
      isTemperatureAdded: this.subsystem_data.is_temperature_added,
      macAddress: this.subsystem_data.mac_address,
      assetType: this.subsystem_data.assetType,
      subAssetType: this.subsystem_data.subType,
      displacementChannels: displacementChannels,
      accelerationChannels: accelerationChannels,
      temperatureChannels: temperatureChannels,
      velocityChannels: velocityChannels,
      sensors_info: sensors_info,
      no_of_axis: no_of_axis,
      latestFFTId: this.latestFFTId,
      latestKurtosisId: this.latestKurtosisId,
      parentAssetId: this.subsystem_data.parentAssetId,
      bearingIsOn: this.subsystem_data.bearingIsOn,
      groupId: this.subsystem_data.groupId,
      // Include all original data as well
      // ...this.subsystem_data
    };
    console.log("------------child component data----", this.childComponentData)
  }

  onNavChange($event) {
    console.log($event)
    this.active_tab_id = $event.nextId;
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  async fetchLastFileTime() {
    try {
      this.loadingLastFileTime = true;
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_DEVICE_LAST_FILE_TIME}${this.subsystem_data.client_id}/${this.subsystem_data.asset_id}`
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.error === false) {
        if (response?.lastFileTime) this.lastFileTime = new ConvertDatetimePipe().convertDateTime(response?.lastFileTime);
        else this.lastFileTime = "N/A";
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingLastFileTime = false;
    }
  }
  async fetchDeviceStatus() {
    try {
      this.loadingDeviceStatus = true;
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_DEVICE_STATUS}${this.subsystem_data.mac_address}`
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.error === false) {
        let tempStatus = response.onlineStatus;
        switch (tempStatus) {
          case 0:
          case 1:
            this.deviceStatus = "ONLINE";
            break;
          case 2:
            this.deviceStatus = "OFFLINE";
            break;
          default:
            this.deviceStatus = "N/A";
            break;
        }
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingDeviceStatus = false;
    }
  }

  async openSettingsModal() {
    try {
      const apiUrl = `${BaseUrlConstantsService.ASSET_METRICS}`;
      const response: any = await this.service.postData(apiUrl, { asset_id: this.subsystem_data.asset_id, user_id: `22${this.subsystem_data.client_id}2222` });
      if (response?.data?.status === "success" && response?.data?.body.length > 0) {
        console.log(this.subsystem_data)
        this.dialog.open(SettingsModalComponent, {
          width: "1200px",
          data: {
            metrics: response.data.body,
            deviceStatus: this.deviceStatus,
            lastFileTime: this.lastFileTime,
            assetId: this.subsystem_data.asset_id,
            is_temperature_added:this.subsystem_data.is_temperature_added,
            master_type:this.subsystem_data.master_type,
            subsystem_id:this.subsystem_data.subsystem_id
          }
        });
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async openServiceModal() {
    try {
      this.loadingService = true;
      const apiUrl = `${BaseUrlConstantsService.BASE_ASSET_SERVICE}/${this.subsystem_data.asset_id}/${this.subsystem_data.mac_address}`;
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.data?.status === "success") {
        this.serviceData = response.data.body;
        const dialogRef = this.dialog.open(ServiceStatusSettingsComponent, {
          width: '800px',
          disableClose: true,
          data: {
            serviceData: this.serviceData,
            assetId: this.subsystem_data.asset_id,
            macAddress: this.subsystem_data.mac_address,
            userId: this.clientId,
            inventoryId: this.subsystem_data.inventory_id
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            console.log("Service status updated successfully")
          }
        })
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingService = false;
    }
  }

  async openAlertSettingsModal() {
    try {
      this.loadingAlertSettings = true;
      const apiUrl = `${BaseUrlConstantsService.BASE_GET_ALERT_SETTINGS}/${this.clientId}/${this.subsystem_data.asset_id}/${this.subsystem_data.master_type}`;
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.data?.status === "success") {
        this.alertSettingsData = response.data.body;
        const dialogRef = this.dialog.open(AlertSettingsComponent, {
          width: '800px',
          maxHeight: '90vh',
          disableClose: true,
          data: {
            alertSettingsData: this.alertSettingsData,
            assetId: this.subsystem_data.asset_id,
            macAddress: this.subsystem_data.mac_address,
            userId: this.clientId,
            inventoryId: this.subsystem_data.inventory_id
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            console.log("Alert settings updated successfully")
          }
        })
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingAlertSettings = false;
    }
  }

  async openPlateDetails() {
    try {
      this.loadingPlateDetails = true;
      const apiUrl = `${BaseUrlConstantsService.ASSETS_DATA_EDIT}/${this.subsystem_data.asset_id}/${this.subsystem_data.mac_address}`;
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.data?.status === "success") {
        this.plateDetailsData = response.data.body;
        const dialogRef = this.dialog.open(PlateDetailsComponent, {
          width: '800px',
          maxHeight: '90vh',
          disableClose: true,
          data: {
            plateDetailsData: this.plateDetailsData,
            assetId: this.subsystem_data.asset_id,
            macAddress: this.subsystem_data.mac_address,
            userId: this.clientId,
            inventoryId: this.subsystem_data.inventory_id
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            console.log("Plate details updated successfully")
          }
        })
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingPlateDetails = false;
    }
  }

    async goToPageLink(name: string) {
    let navigationExtras = {
      skipLocationChange: true,
      queryParams: {
          tabName : 'tab-1',
          powertrain:true
        },
    };
    this.rt.navigate([name],navigationExtras);
  }

}
